module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject-form__prep-factor-wrap",
    class: [_vm.wrapClass, {
      'subject-form__prep-factor-wrap--binary': _vm.isBinaryPrepTask
    }]
  }, [(_vm.isBinaryPrepTask) ? [_c('div', {
    staticClass: "d-label-and-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onPrepToggle(!_vm.isPrepExtraOn)
      }
    }
  }, [_c('label', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: (_vm.toggleTippyOptions),
      expression: "toggleTippyOptions"
    }],
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.labels.prep_task_extra_toggle))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.isPrepExtraOn,
      "allowChanges": false
    }
  })], 1)] : [_c('label', {
    staticStyle: {
      "margin-bottom": "6px"
    }
  }, [_vm._v(_vm._s(_vm.labels.forb_faktor))]), _vm._v(" "), _c('div', {
    staticClass: "input-group--flex subject-form__prep-factor-inner"
  }, [(!_vm.isDanishPreparationFactorEditing) ? [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "subject-form__prep-factor-display"
  }, [_vm._v(_vm._s(_vm.formattedDanishPreparationFactor))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group--flex__setting-icon"
  }, [_c('div', {
    staticClass: "icon__bg-circle",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": _vm.openDanishPreparationFactorEdit
    }
  }, [_c('span', {
    staticClass: "icon-wrench"
  })])])] : [_c('div', {
    staticClass: "flex-1"
  }, [_c('input', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: (_vm.numericTippyOptions),
      expression: "numericTippyOptions"
    }],
    ref: "inputDanishPreparationFactor",
    class: _vm.inputClass,
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "-1",
      "max": "1"
    },
    domProps: {
      "value": _vm.numericEditDraft
    },
    on: {
      "input": _vm.onDanishPreparationFactorInput,
      "blur": _vm.onDanishPreparationFactorBlur,
      "focus": _vm.selectAllOnFocus
    }
  })])]], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dd80cc82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/DkPreparationFactorControl.vue
// module id = 2141
// module chunks = 1